var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPlaceholerImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0H1C0.4475 0 0 0.4475 0 1V26C0 27.1044 0.895625 28 2 28H38C39.1044 28 40 27.1044 40 26V1C40 0.4475 39.5525 0 39 0ZM38 26H2V8H38V26ZM38 6H2V2H38V6ZM6.5 22H15.5C15.7762 22 16 21.7763 16 21.5V20.5C16 20.2237 15.7762 20 15.5 20H6.5C6.22375 20 6 20.2237 6 20.5V21.5C6 21.7763 6.22375 22 6.5 22ZM24.5 22H33.5C33.7762 22 34 21.7763 34 21.5V20.5C34 20.2237 33.7762 20 33.5 20H24.5C24.2237 20 24 20.2237 24 20.5V21.5C24 21.7763 24.2237 22 24.5 22ZM6.5 16H19.5C19.7763 16 20 15.7762 20 15.5V14.5C20 14.2238 19.7763 14 19.5 14H6.5C6.22375 14 6 14.2238 6 14.5V15.5C6 15.7762 6.22375 16 6.5 16ZM25 16H33C33.5525 16 34 15.5525 34 15V11C34 10.4475 33.5525 10 33 10H25C24.4475 10 24 10.4475 24 11V15C24 15.5525 24.4475 16 25 16ZM26 12H32V14H26V12Z",
    fill: "#005E9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPlaceholerImage);
export default __webpack_public_path__ + "static/media/CheckPlaceholerImage.19b05821ef04c080cdde7119aff49d3c.svg";
export { ForwardRef as ReactComponent };